import React, { useState } from 'react'
import {
    Header,
    Button,
    Paragraph,
    MortgageRegulationContacts, 
    ErrorMark
} from "../../../components/RegularComponents";
import TopNavigationBar from "../../TopNavigationBar";
import * as CONST from "../../../app/constants";
import { useDispatch, useSelector } from 'react-redux';
import { push } from 'connected-react-router';
import { agencyApplicationSelector } from "../../../redux/selector/agencyApplicationSelector";
import { applicationTypeFromLicenceSubType } from '../../../redux/slice/applicationsUtils';
import { setMortgageProperty } from '../../../redux/slice/primaryAgencyApplicationSlice';


export const RenewalRegulationAct = (props) => {

    const { agencyApplication }  = useSelector(
        agencyApplicationSelector
    );
    const isMRACompliance = agencyApplication.businessLicenceData.isMRACompliance;

    const { isModal = false, onEditSave = () => {} } = props;
    const [selectedOption,setSelectedOption] = useState(isMRACompliance ? "yes" :(isMRACompliance === false ? "no" : ""));
    const dispatch = useDispatch();
    
    const handleContinue = () => {
        
        if(selectedOption === "no") {
            return
        }

        if(isModal) {
            onEditSave()
        } else {
            const applicationType = applicationTypeFromLicenceSubType(agencyApplication.licencingSubType)
       
            // console.log({applicationType})
            let nextUrl = CONST.ROUTE_PATH.ML_APP
            if(applicationType === CONST.APPLICATION_TYPE_MORTGAGE_ADMINISTRATOR_LICENCE) {
                nextUrl = CONST.ROUTE_PATH.MA_APP
            }
            dispatch(
                push(
                    `${nextUrl}${CONST.ROUTE_PATH.RENEWAL_AIR_SUBMISSION}`
                )
            );
        }
    }

    const onYesClick = () => {
        setSelectedOption("yes")
        dispatch(
            setMortgageProperty({
                key: "isMRACompliance",
                value: true
            })
        );
    }

    const onNoClick = () => {
        setSelectedOption("no")
        dispatch(
            setMortgageProperty({
                key: "isMRACompliance",
                value: false
            })
        );
    }

    return (
        <div className={!isModal ? "container" : ""}>
        
        {!isModal && <TopNavigationBar {...props} />}
        
        <div className="row">
                {!isModal && 
                <div className="col-xs-12 col-lg-11">
                    <Header
                        id="ml-renewal-confirm-pb-header"
                        header="Compliance with the Mortgage Regulation Act"
                    />
                </div>}
                <div className="col-xs-12 col-lg-11 topMarginMedium">
                    <Paragraph
                        id="ml-renewal-compliance-text-1"
                        text={[
                            `It is your responsibility to be in compliance with <a href="${CONST.MRA_REGULATION_ACT_DOCUMENT_LINK}" target="blank">the Mortgage Regulation Act (MRA)</a> and <a href="${CONST.MRA_REGULATION_JUSTICE_LINK}" target="blank"> regulations</a>.`,
                        ]}
                    />
                    <Paragraph
                        id="ml-renewal-compliance-text-2"
                        style={{fontWeight: "bold", fontSize: "1.2em"}}
                        text={[
                            `Are you in compliance with the Mortgage Regulation Act?`,
                        ]}
                    />
                </div>
            </div>
        
        <div className={"row"}>
            <div className={"col-8"}>
                <fieldset className={"ns-fieldset" + (selectedOption === "no" ? " ns-fieldset-message-error" : "")}>
                    <div className={"ns-radios ns-radios--small"}>
                        <div 
                            key={"ml-renewal-compliance-yes"} 
                            className="ns-radios__item" style={{marginBottom: "15px"}}
                            onClick={onYesClick}
                        >
                            <input
                                className="ns-radios__input"
                                key={"ml-renewal-compliance-yes-input"}
                                type={"radio"}
                                value={"yes"}
                                checked={selectedOption === "yes"}
                                onClick={onYesClick}
                                id={
                                    "ml-renewal-compliacne-yes-input"
                                }
                                name={"ml-renewal-compliance-group"}
                            />
                            <label
                                key={"ml-yes-label"}
                                id={
                                "ml-renewal-compliance-yes-label"
                                }
                                className="ns-radios__label"
                                htmlFor={
                                "ml-renewal-compliance-yes-input"
                                }
                            >
                                <span className="ns-label-span">
                                    Yes
                                </span>
                            </label>
                        </div>
                        <div 
                            key={"ml-renewal-compliance-no"} 
                            className="ns-radios__item"
                            onClick={onNoClick}
                        >
                            <input
                                className="ns-radios__input"
                                key={"ml-renewal-compliance-no-input"}
                                type={"radio"}
                                value={"no"}
                                checked={selectedOption === "no"}
                                onClick={onNoClick}
                                id={
                                    "ml-renewal-compliacne-no-input"
                                }
                                name={"ml-renewal-compliance-group"}
                            />
                            <label
                                key={"ml-no-label"}
                                id={
                                "ml-renewal-compliance-no-label"
                                }
                                className="ns-radios__label"
                                htmlFor={
                                "ml-renewal-compliance-no-input"
                                }
                            >
                                <span className="ns-label-span">
                                    No
                                </span>
                            </label>
                        </div>
                        {selectedOption === "no" && 
                            <MortgageRegulationContacts message="You must be in compliance to continue the renewal.
                             Please contact Business Licensing to discuss your application." />
                        }
                    </div>
                </fieldset>
            </div>
        </div>

        <div className="row">
            <div className="col-lg-8">
                <div className="col-xs-3">
                    <Button
                    className="btn-lg btn-default"
                    buttonType={"regular_primary"}
                    text={!isModal ? "Continue" : "Save and close"}
                    onClick={handleContinue}
                    />
                    {selectedOption === "no" && ErrorMark()}
                </div>
            </div>
        </div>
    </div>
    )
}